import * as React from 'react';
import { memo } from 'react';

const SvgPaperPlaneTilt = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.543 3.305 1.98 7.406a.625.625 0 0 0-.094 1.172l6.688 3.164a.61.61 0 0 1 .297.297l3.164 6.688a.625.625 0 0 0 1.172-.094L17.308 4.07a.617.617 0 0 0-.765-.765v0ZM8.777 11.836l3.531-3.531", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgPaperPlaneTilt);

export { Memo as default };
